import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  IconButton, Tooltip, Chip, TablePagination, Box, TableSortLabel,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import useSortTable from '../../../hooks/useSortTable';

const RoleTable = ({ roles, onEdit, onDelete, onViewPermissions, page, onPageChange, pagination, canEdit, canDelete }) => {
  const { sorted, sortBy, sortDir, handleSort } = useSortTable(roles);

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage + 1);
  };

  const SortCell = ({ label, field, align }) => (
    <TableCell align={align} onClick={() => handleSort(field)} sx={{ cursor: 'pointer', userSelect: 'none' }}>
      <TableSortLabel active={sortBy === field} direction={sortBy === field ? sortDir : 'asc'}>
        {label}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <SortCell label="NOMBRE" field="name" />
              <SortCell label="NIVEL DE ROL" field="roleLevel" align="center" />
              <TableCell align="center">PERMISOS</TableCell>
              <TableCell align="right">ACCIONES</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No se encontraron roles
                </TableCell>
              </TableRow>
            ) : (
              sorted.map((role) => (
                <TableRow
                  key={role.id}
                  hover
                  onClick={() => onViewPermissions(role)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>
                    <Box>
                      <Box sx={{ fontWeight: 500 }}>{role.name}</Box>
                      {role.company ? (
                        <Box sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                          {role.company.name}
                        </Box>
                      ) : (
                        <Chip label="Sistema" size="small" sx={{ mt: 0.5, height: 20, fontSize: '0.7rem', bgcolor: 'grey.100' }} />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={role.roleLevel || 'N/A'}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={role.roleHasPermissions?.length || 0}
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="right">
                    {canEdit && (
                      <Tooltip title={!role.companyId ? "Los roles del sistema no se pueden editar" : "Editar"}>
                        <span>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={(e) => { e.stopPropagation(); onEdit(role); }}
                            disabled={!role.companyId}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                    {canDelete && (
                      <Tooltip title={!role.companyId ? "Los roles del sistema no se pueden eliminar" : "Eliminar"}>
                        <span>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={(e) => { e.stopPropagation(); onDelete(role.id); }}
                            disabled={!role.companyId}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <TablePagination
          component="div"
          count={pagination.total}
          page={page - 1}
          onPageChange={handleChangePage}
          rowsPerPage={pagination.limit}
          rowsPerPageOptions={[10]}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        />
      )}
    </Paper>
  );
};

export default RoleTable;
